// Case study content for portfolio
//
// VIDEO HOSTING NOTES
// • videoUrl can be either:
//     1) A YouTube/Vimeo EMBED URL (e.g., "https://www.youtube.com/embed/VIDEO_ID"
//        or "https://player.vimeo.com/video/VIDEO_ID")
//     2) A direct .mp4 URL — it will play with native <video> controls
// • Leave videoUrl: null to show just the hero image with a play-icon overlay.
// • The 3 video case studies below are populated with free Mixkit sample reels
//   as placeholders. Swap them for your real client videos any time.
export const caseStudies = {
  "rooted-coffee": {
    kind: "video",
    client: "Rooted Coffee Roasters",
    tag: "Product spotlight",
    title: "A 15-second pour that tripled our weekend walk-ins",
    hero: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=1600&q=80",
    videoUrl: "https://assets.mixkit.co/videos/4546/4546-720.mp4",
    kpis: [
      { label: "Reach", value: "+412%" },
      { label: "New followers", value: "+2.1k" },
      { label: "Weekend walk-ins", value: "+3.2x" },
    ],
    before: "A gorgeous roast nobody saw. Posts were static shots with low engagement, averaging 180 views and 6 likes.",
    after: "A 15-second close-up pour, shot on a counter and cut to a trending audio. Posted 4x a week with varied angles and seasonal flavours.",
    gallery: [
      "https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1498804103079-a6351b050096?auto=format&fit=crop&w=800&q=80",
    ],
    quote: {
      text: "Our weekend queue is out the door now. People walk in holding up the video on their phone. The team at Design My Story got what makes our shop special in one meeting.",
      author: "Hannah Reyes",
      role: "Owner · Rooted Coffee Roasters",
    },
  },
  "north-and-main-barber": {
    kind: "video",
    client: "North & Main Barber Co.",
    tag: "Behind the scenes",
    title: "Faces behind the chairs, and the booking app that followed",
    hero: "https://images.unsplash.com/photo-1621605815971-fbc98d665033?auto=format&fit=crop&w=1600&q=80",
    videoUrl: "https://assets.mixkit.co/videos/4645/4645-720.mp4",
    kpis: [
      { label: "Follower growth", value: "+1.2k" },
      { label: "Avg. views / reel", value: "22k" },
      { label: "Online bookings", value: "3x" },
    ],
    before: "No social presence. Walk-ins only. New customers were asking friends where to go.",
    after: "A weekly series: 'Meet the chair.' One barber, one cut, one story in 30 seconds. Paired with a booking button in the bio.",
    gallery: [
      "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1621605815971-fbc98d665033?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=800&q=80",
    ],
    quote: {
      text: "We went from being the shop no one knew about to a two-week wait list. The videos tell our story and the booking site closes the sale while we sleep.",
      author: "Marcus Hale",
      role: "Owner · North & Main Barber Co.",
    },
  },
  "hazel-and-hem": {
    kind: "video",
    client: "Hazel & Hem Bridal",
    tag: "Customer story",
    title: "A bride-to-be says it best — 9 bookings in 7 days",
    hero: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=1600&q=80",
    videoUrl: "https://assets.mixkit.co/videos/39775/39775-720.mp4",
    kpis: [
      { label: "Bookings in 7 days", value: "9" },
      { label: "Reach", value: "+288%" },
      { label: "Cost per booking", value: "–71%" },
    ],
    before: "Beautiful dresses but static feed photos. The emotion of trying on 'the one' never made it to a reel.",
    after: "A real bride tells her story on camera: the dress, the moment, the staff. Three 20-second cuts posted across a week.",
    gallery: [
      "https://images.unsplash.com/photo-1591604466107-ec97de577aff?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?auto=format&fit=crop&w=800&q=80",
    ],
    quote: {
      text: "The video made me cry, and apparently it did the same for nine other brides in a week. Our calendar is full through October.",
      author: "Sofia Martínez",
      role: "Founder · Hazel & Hem Bridal",
    },
  },
  "north-and-main-site": {
    kind: "site",
    client: "North & Main Barber Co.",
    tag: "Service business",
    title: "northandmain.co — fresh cuts, easy booking",
    hero: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80",
    videoUrl: null,
    url: "northandmain.co",
    kpis: [
      { label: "Online bookings", value: "3x more" },
      { label: "Mobile traffic", value: "72%" },
      { label: "Build time", value: "2 weeks" },
    ],
    before: "A Facebook page as a homepage. No way to book without calling. Phone rang off the hook on Mondays.",
    after: "A one-page site with a booking button on every screen, a photo wall of the shop, and the team's stories inline.",
    gallery: [
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?auto=format&fit=crop&w=800&q=80",
    ],
    quote: {
      text: "Monday mornings used to be a nightmare. Now the site handles bookings and I just cut hair.",
      author: "Marcus Hale",
      role: "Owner · North & Main Barber Co.",
    },
  },
  "hazel-and-hem-shop": {
    kind: "site",
    client: "Hazel & Hem Bridal",
    tag: "Online store",
    title: "hazelandhem.shop — a bridal store that converts",
    hero: "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=1600&q=80",
    videoUrl: null,
    url: "hazelandhem.shop",
    kpis: [
      { label: "First-month sales", value: "$14k" },
      { label: "Add-to-cart rate", value: "9.4%" },
      { label: "Returning visitors", value: "38%" },
    ],
    before: "A linktree with four product photos and no way to pay. Brides messaging on Instagram for prices.",
    after: "A clean online shop with filters, a story page for each dress, and Stripe checkout. Launched with a video campaign.",
    gallery: [
      "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1591604466107-ec97de577aff?auto=format&fit=crop&w=800&q=80",
    ],
    quote: {
      text: "We did more in our first month online than in our first six months of DMs. The site feels like us.",
      author: "Sofia Martínez",
      role: "Founder · Hazel & Hem Bridal",
    },
  },
  "lamplight-candle": {
    kind: "site",
    client: "Lamplight Candle Co.",
    tag: "Faith / lifestyle brand",
    title: "lamplightcandle.co — faith-rooted candles, hand-poured",
    hero: "https://images.unsplash.com/photo-1602874801007-aa70d2dd5848?auto=format&fit=crop&w=1600&q=80",
    videoUrl: null,
    url: "lamplightcandle.co",
    kpis: [
      { label: "Returning customers", value: "42%" },
      { label: "Avg. order value", value: "$46" },
      { label: "Email signups", value: "1.8k" },
    ],
    before: "Markets only. Loyal customers but no way to buy between fairs. No way to tell the story behind each scent.",
    after: "A brand site with a scent-of-the-month, a verse paired with every candle, and a simple shop with Stripe checkout.",
    gallery: [
      "https://images.unsplash.com/photo-1602874801007-aa70d2dd5848?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1601056639638-c0daf21e5e97?auto=format&fit=crop&w=800&q=80",
    ],
    quote: {
      text: "The site tells our 'why' before people even look at the candles. That's what makes them stay.",
      author: "Ruth Bennett",
      role: "Founder · Lamplight Candle Co.",
    },
  },
};
